"use client"

export const ERROR_BOUNDARY_EVENTS = {
  BOUNDARY_RENDERED: "error_boundary_rendered",
  CORRELATION_COPIED: "error_boundary_correlation_copied",
} as const

export const ERROR_BOUNDARY_PROPERTIES = {
  CORRELATION_ID: "correlation_id",
  BOUNDARY_SCOPE: "boundary_scope",
  IS_NOT_FOUND_VARIANT: "is_not_found_variant",
} as const

function toShortHash(input: string): string {
  let hash = 5381
  for (let index = 0; index < input.length; index += 1) {
    hash = (hash * 33) ^ input.charCodeAt(index)
  }
  return Math.abs(hash).toString(36).slice(0, 6).padEnd(6, "0")
}

export function buildCorrelationId(error: Error): string {
  const date = new Date().toISOString().slice(0, 10)
  const entropySeed = `${error.message}:${error.stack ?? ""}:${Date.now()}:${Math.random()}`
  return `CRX-${date}-${toShortHash(entropySeed)}`
}

export function isNotFoundBoundaryVariant(error: Error): boolean {
  const unknownError = error as Error & { code?: string; digest?: string }
  const diagnostic = `${unknownError.message ?? ""} ${unknownError.code ?? ""} ${unknownError.digest ?? ""}`.toLowerCase()
  return diagnostic.includes("notfound") || diagnostic.includes("not_found") || diagnostic.includes("404")
}

export function trackBoundaryEvent(
  eventName: string,
  properties: Record<string, string | boolean>,
): void {
  if (typeof window === "undefined") return
  const posthog = (window as Window & { posthog?: { capture?: (event: string, properties?: Record<string, unknown>) => void } }).posthog
  posthog?.capture?.(eventName, properties)
}
